import React, {useState, useEffect} from 'react';
import styled from 'styled-components'
import {currentNotification$} from '../../supplementary_components/store';



const handleColorType = type => {
    switch (type) {
        case "notify":
            return "var(--gray)";
        case 'success':
            return "rgba(48, 192, 140, 0.7);";
        case "alert":
            return "var(--alert-color)";
        case 'warn':
            return "var(--yellow-alert-color)";
        default:
            return "null";
    }
};
const NotificationWrapped = styled.div`
    z-index:1000;
    position: fixed;
    left: 50%;
    bottom:0;
    transform: translate(-50%, 0);
    margin-bottom:1.5rem;
    padding: 0.5rem 1.5rem;
    font-size:1.1rem;
    font-weight:600;
    border-radius:1.5rem;
    color: var(--bg);
    transition:0.3s;
    opacity: ${props => props.state ? '1.0' : '0'};

    background:${({ type }) => handleColorType(type)};

`;


export const NotificationManager = ()=> {
    const [data, setData] = useState(null);
    const [msg, setMsg] = useState(null);

    const _setData = (data)=>{
        if (data !== null){
            setMsg(data);
        }else{
            setTimeout(()=>{
                setMsg(null);
            }, 1000)
        }
        setData(data);
    }
    useEffect(() => {
        const sub = currentNotification$.subscribe(_setData);
        return () => sub.unsubscribe();
    }, [])
    return <NotificationWrapped 
        state={data}
        type={msg? msg.type : null}>
        {msg ? msg.message: null}
    </NotificationWrapped>;

} 